document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.img-with-content-slider').forEach(function (el) {

    new Splide(el, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      arrows: true,
      autoplay: false,
       interval: 4000,
       speed: 800,
      pagination: true,
      gap: '20px',
      speed: 800,
      breakpoints: {
        1199: {
          arrows: false,
          pagination: true
        }
      },
    }).mount();

  });

});